import { render, staticRenderFns } from "./ClientLogo.vue?vue&type=template&id=474af0c8&scoped=true&"
import script from "./ClientLogo.vue?vue&type=script&lang=js&"
export * from "./ClientLogo.vue?vue&type=script&lang=js&"
import style0 from "./ClientLogo.vue?vue&type=style&index=0&id=474af0c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474af0c8",
  null
  
)

export default component.exports